"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("../../styles/BaseCard.scss");
const BaseCard = (props) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "base-card", children: [props.title && ((0, jsx_runtime_1.jsx)("div", { className: "base-card--title", children: props.title })), (0, jsx_runtime_1.jsx)("div", { className: "base-card--text", children: props.text }), props.footer] }));
};
exports.BaseCard = BaseCard;
